import { gql } from '@apollo/client'

export const JOB_APPLICANT_FRAGMENT = gql`
	fragment jobApplicantFragment on Job {
		id
		externalId
		jobApplicant {
			id
			status
			atsStatus
			progressTracking
			interview {
				interviewSlot {
					id
					interviewLink
					interviewType
					startDatetime
					endDatetime
				}
			}
			acceptOfferChecked
		}
		availableInterviewSlots {
			endDatetime
			startDatetime
			id
			interviewLink
			interviewType
			duration
			timezone
		}
		canRequestInterview
	}
`
